import { Box, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { baseUrl } from "@jumbo/constants/baseUrl";
import { Cancel } from "@material-ui/icons";
import { LocalMovies } from "@material-ui/icons";
import { useMediaQuery } from "@material-ui/core";
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from "react-grid-dnd";

const useStyles = makeStyles((theme) => ({
  uploadedContainer: {
    direction: "rtl !important",
    width: "100%",
    padding: "20px",
    borderWidth: "2px",
    borderStyle: "dashed",
    borderColor: theme.palette.grey[400],
    borderRadius: "5px",
    marginBlock: "20px",
    textAlign: "center",
  },
  uploadText: {
    color: theme.palette.grey[400],
  },
  mediaContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  mediaElement: {
    position: "relative",
    width: 150,
    height: 150,
    borderRadius: 5,
    overflow: "hidden",
    margin: 10,
    background: "transparent",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  imageContainer: {
    position: "absolute",
    top: "0",
    right: "0",
    width: "100%",
    height: "100%",
    zIndex: "-1",
  },
  ovelay: {
    width: "100%",
    height: "100%",
    background: "transparent",
    zIndex: "5",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  removeIcon: {
    color: "rgba(0, 0, 0, 0.7)",
    cursor: "pointer",
    margin: "4px",
  },
  nameContainer: {
    position: "absolute",
    bottom: 0,
    right: "0",
    width: "100%",
    height: "40px",
    background: "rgba(0, 0, 0, 0.7)",
    color: "#fff",
    textAlign: "center",
    fontSize: "13px",
    lineHeight: "40px",
  },
  iconContainer: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "-1",
  },
}));

function shortenFilename(filename, maxLength) {
  if (filename.length <= maxLength) return filename;

  const prefixLength = Math.ceil((maxLength - 3) / 2);
  const suffixLength = Math.floor((maxLength - 3) / 2);

  return (
    filename.substr(0, prefixLength) +
    "..." +
    filename.substr(filename.length - suffixLength)
  );
}

const UploadedSection = ({ allMedia, setMedia }) => {
  const classes = useStyles();
  const isXs = useMediaQuery("(max-width:600px)");
  const isSm = useMediaQuery("(max-width:960px)");

  let boxesPerRow;
  if (isXs) {
    boxesPerRow = 1;
  } else if (isSm) {
    boxesPerRow = 2;
  } else {
    boxesPerRow = 4;
  }

  const rowCount = Math.ceil(allMedia.length / boxesPerRow);
  const gridHeight = rowCount * 180;

  function onChange(sourceId, sourceIndex, targetIndex, targetId) {
    const newMediaArray = swap(allMedia, sourceIndex, targetIndex);
    setMedia(newMediaArray);
  }

  const handleRemove = (curr) => {
    let mediaCopy = [...allMedia];
    mediaCopy = mediaCopy.filter((media) => {
      return media._id !== curr;
    });
    setMedia(mediaCopy);
  };

  const getPreview = (fileName) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    const extension = fileName
      .split(".")
      .pop()
      .toLowerCase();
    let fileType = "";
    if (imageExtensions.includes(extension)) {
      return (fileType = (
        <img
          crossOrigin="anonymous"
          className={classes.imageContainer}
          src={`${baseUrl}file/get/${fileName}`}
          alt="cover"
        />
      ));
    } else {
      fileType = (
        <Box className={classes.iconContainer}>
          <LocalMovies fontSize="large" color="disabled" />
        </Box>
      );
    }
    return fileType;
  };

  return (
    <Box className={classes.uploadedContainer}>
      {allMedia.length !== 0 ? (
        <GridContextProvider onChange={onChange}>
          <GridDropZone
            id="items"
            boxesPerRow={boxesPerRow}
            rowHeight={180}
            style={{
              height: gridHeight,
            }}
          >
            {allMedia.map((media) => {
              return (
                <GridItem key={media._id}>
                  <Box className={classes.container}>
                    <Box className={classes.mediaElement}>
                      <Box className={classes.ovelay}>
                        <Box onClick={() => handleRemove(media._id)}>
                          <Cancel
                            className={classes.removeIcon}
                            fontSize="medium"
                          />
                        </Box>
                      </Box>
                      {getPreview(media.name)}
                      <Box className={classes.nameContainer}>
                        {shortenFilename(media.name, 20)}
                      </Box>
                    </Box>
                  </Box>
                </GridItem>
              );
            })}
          </GridDropZone>
        </GridContextProvider>
      ) : (
        <Typography className={classes.uploadText}>
          موردی برای نمایش وجود ندارد
        </Typography>
      )}
    </Box>
  );
};

export default UploadedSection;
